import api from '@/services/api';
import { useEffect, useState } from 'react';

interface Tool {
  id: string;
  name: string;
  global: boolean;
}

interface Model {
  id: string;
  name: string;
}

export const useConfigAssistant = ({ auto }: { auto: boolean }) => {
  const [availableTools, setAvailableTools] = useState<Tool[]>([]);
  const [availableModels, setAvailableModels] = useState<Model[]>([]);
  const [loadingTools, setLoadingTools] = useState(false);
  const [loadingModels, setLoadingModels] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const getAvailableTools = async () => {
    try {
      setLoadingTools(true);
      const response = await api.get('/api/v1/assistants/available_tools', {
        withCredentials: true,
      });
      setAvailableTools(response.data);
    } catch (error) {
      setError(error as string);
    } finally {
      setLoadingTools(false);
    }
  };
  const getAvailableModels = async () => {
    try {
      setLoadingModels(true);
      const response = await api.get('/api/v1/assistants/available_models', {
        withCredentials: true,
      });
      setAvailableModels(response.data);
    } catch (error) {
      setError(error as string);
    } finally {
      setLoadingModels(false);
    }
  };

  useEffect(() => {
    if (auto) {
      getAvailableTools();
      getAvailableModels();
    }
  }, [auto]);

  return {
    availableTools,
    availableModels,
    loadingTools,
    loadingModels,
    error,
    getAvailableTools,
    getAvailableModels,
  };
};
